import _ from 'lodash';
import { loggedIn, loggedInUser, userService } from '@mobile/services/user';
import PushService from '@mobile/services/push';
import { eventBus } from '@/eventBus';

export default {
    namespaced: true,
    state: getDefaultState(),
    actions: {
        login({ dispatch, commit }, { email, password }) {
            commit('loginRequest', { email });

            userService.login(email, password)
                .then(() => {
                    userService.me()
                        .then(async (user) => {
                            commit('loginSuccess');
                            commit('setUser', user);
                            eventBus.$emit('login', user);
                            await PushService.subscribe();
                        });
                    dispatch('notifications/unreadCount', null, { root: true });
                })
                .catch((error) => {
                    commit('loginFailure', error);
                    eventBus.$emit('error', window.i18n.t('Login error!'));
                });
        },
        async logout({ commit }) {
            await PushService.unsubscribe();
            userService.logout()
                .then(async () => {
                    commit('reset', {});
                    eventBus.$emit('logout');
                })
                .catch(() => {
                    eventBus.$emit('error', window.i18n.t('Logout error!'));
                });
        },
        versionUpdated({ commit }) {
            userService.me()
                .then((user) => {
                    commit('setUser', user);
                });
        },
        userUpdated({ commit }, newUser) {
            userService.updateUser(newUser);
            commit('setUser', newUser);
        },
        userSubscriptionUpdated({ commit }, newUserSubscription) {
            userService.updateUserSubscription(newUserSubscription);
            commit('setUserSubscription', newUserSubscription);
        },
        userInspectionCountUpdated({ commit }, inspection) {
            userService.updateUserSubscriptionInspections(inspection);
            commit('setUserSubscriptionInspection', inspection);
            eventBus.$emit('inspections-updated');
        },
    },
    mutations: {
        loginRequest(state) {
            state.loggingIn = true;
        },
        loginSuccess(state) {
            state.loggingIn = false;
            state.loggedIn = true;
        },
        loginFailure(state) {
            state.loggingIn = false;
        },
        setUser(state, user) {
            state.user = user;
        },
        setUserSubscription(state, subscription) {
            _.set(state.user, 'subscription', subscription);
        },
        setUserSubscriptionInspection(state, inspection) {
            _.set(state.user, 'subscription.inspections', inspection);
        },
        reset(state) {
            Object.assign(state, getDefaultState());
        },
    },
    getters: {
        user: (state) => state.user,
        hasPermission: (state) => (permission) => state.user !== null
            && Array.isArray(state.user.permissions)
            && state.user.permissions.includes(permission),
        hasAnyPermissions: (state) => (permissions) => {
            if (!state.user) return false;
            if (!state.user.permissions && !Array.isArray(state.user.permissions)) return false;

            const checkPermissions = (constraint) => state.user.permissions.includes(constraint);

            if (Array.isArray(permissions)) return permissions.filter(checkPermissions).length > 0;
            return checkPermissions(permissions);
        },
        loggedIn: (state) => state.loggedIn,
    },
};

function getDefaultState() {
    return {
        user: loggedInUser(),
        loggedIn: loggedIn(),
        loggingIn: false,
    };
}
